import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { Component, Input, forwardRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { DetectMobileService } from '@tripointe/tripointe-cms/services';
import { Observable } from 'rxjs';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';

import { DATE_MODIFIERS } from './datepicker.utils';

const DATEPICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DatepickerComponent),
  multi: true
};

@Component({
  selector: 'tp-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  providers: [
    DATEPICKER_VALUE_ACCESSOR,
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
  ]
})
export class DatepickerComponent implements ControlValueAccessor {
  @Input() innerLabel: string;
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Input() modifier: string;

  @ViewChild('datepicker', { static: false }) datepicker: MatDatepicker<any>;

  isMobileView$: Observable<boolean>;
  selectedDate = null;
  propagateChange = (_: any) => {};
  onTouched = () => {};
  onChange = (value: any) => {};

  constructor(private detectMobileViewService: DetectMobileService) {
    this.isMobileView$ = this.detectMobileViewService.isMobileView();
  }

  writeValue(value: string): void {
    this.selectedDate = value;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  openDatepicker(): void {
    this.datepicker.open();
  }

  onDateChange(date: MatDatepickerInputEvent<Date>): void {
    const dateModifierFn = DATE_MODIFIERS[this.modifier];

    this.selectedDate = dateModifierFn ? dateModifierFn(date.value) : date.value;
    this.propagateChange(this.selectedDate);
    this.onTouched();
  }
}
